  if (!customElements.get('studio-finish-preview')) {
    customElements.define('studio-finish-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const picture = this.querySelector('img');
        if (!picture) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const fallback = () => {
          if (this.classList.contains('is-fallback') || !this.dataset.fallback) return;
          this.classList.add('is-fallback');
          picture.src = this.dataset.fallback;
        };
        picture.addEventListener('error', fallback, {signal});
        if (picture.complete && !picture.naturalWidth) fallback();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
